// Left panel — shown when the app IS running but nobody is signed in.
//
// This is deliberately NOT the install panel: the app was found, so telling the
// user to download it would be wrong. We show the same device card as the
// signed-in state (it renders "Signed out") plus a button that hands this
// dashboard session straight over to the app — no retyping a password.
//
// `handoff` is owned by the page (see Connect/index.js) and shared with the
// rail, so whichever button you press locks both.
import styles from "../Connect.module.css";
import DeviceCard from "./DeviceCard";
import useThisDevice from "../useThisDevice";

export default function SignedOutPanel({ handoff }) {
  const device = useThisDevice();
  const { signIn, pending, error } = handoff;

  return (
    <section className={styles.panel}>
      <h2 className={styles.panelTitle}>PQ VPN is installed on this device</h2>
      <p className={styles.panelSubtitle}>
        The app is running but no account is signed in. Sign it in with your
        dashboard session — no password needed.
      </p>

      <div className={styles.deviceList}>
        <DeviceCard
          device={device}
          onOpenInApp={signIn}
          openInAppLabel={pending ? "SIGNING IN…" : "SIGN IN TO THE APP"}
          openInAppDisabled={pending}
        />
      </div>

      {error && <p className={styles.handoffError}>{error}</p>}

      <p className={styles.deviceListNote}>
        Nothing to install — we found the app on this machine. Signing in hands
        your current session to the app; this page updates on its own once it
        takes effect.
      </p>
    </section>
  );
}
